import { Stack, Tooltip, Typography } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

type VesselVisitViewAttributeProps = { label: string; value: string }

export const VesselVisitViewAttribute = ({ label, value }: VesselVisitViewAttributeProps) => {
  const theme = useMinimalsTheme()

  return (
    <Stack direction={'row'} spacing={1}>
      <Typography
        variant='body2'
        color={theme.palette.text.secondary}
        sx={{ whiteSpace: 'nowrap' }}
      >
        {label}:
      </Typography>
      <Tooltip title={value}>
        <Typography
          variant='subtitle2'
          color={theme.palette.text.secondary}
          overflow='hidden'
          whiteSpace='nowrap'
          textOverflow='ellipsis'
        >
          {value}
        </Typography>
      </Tooltip>
    </Stack>
  )
}
